import React, {useState} from "react";
import './ContactsData.scss';
import avatar_img from '../../../../styles/avatar_default.png';
import Config from '../../../../config/config';
import { addMessage } from "../../../Authorization/authSlice";
import { setOpenSendBox, onShadeView } from "../../Contacts/contactsSlice";

const ContactsData= (props) => {
    const { dispatch } = props;
    const [selectedContactId, setSelectedContactId] = useState();
    const [textMessage, setTextMessage] = useState('Посмотрите данную ссылку.');
    
// ADD TEXT TO MESSAGE
const handleTextMessage = (e) => {
    const  text = e.target.value;
    setTextMessage(text);
}



// ON CLICK SEND BUTTON
    const onClickSend = (e) => {
        const selectedContactId = e.currentTarget.value;
let mesTitle;
let mesItemId;

if (props.mesHref === '2') {
    mesTitle = props.noteData.selectedNoteName;
    mesItemId = props.noteData.selectedNoteId;
}
if (props.mesHref === '1') {
    mesTitle = props.quizName;
    mesItemId = props.quizId;
}





        const dataMessage = {
            userId:props.userId,
            contactId:selectedContactId,
            title:mesTitle,
            text:textMessage,
            mesHref:props.mesHref,
            itemId:mesItemId,
            notePart:"0",
            mesCategory:props.mesCategory,
            
        }
        console.log(dataMessage);
         dispatch(addMessage(dataMessage));
       props.onClickOpenContactUser();
        dispatch(setOpenSendBox());
        dispatch(onShadeView());


    }

    //CHECK CONTACT
    const onClickContact = (e) => {
        const selectContact = Number(e.target.value);
        setSelectedContactId(selectContact);
    }

    
   const serverPath = Config.serverPath;
 

    //RENDER
    const renderContactsData = () => {
        
            let data = props.contactsData;
            console.log(data);
        
        
        
        
        if (data) {
            return (
                data.map(item => {
                    if (item.confirmed) {

                          
                    let avatarName= item.avatarname;
                    console.log(avatarName);
                    
                    let avatar_src = avatar_img;
                    if (avatarName) {
                        avatar_src = `${serverPath}/api/avatar/${item.id}/${item.avatarname}`;
                    }
                   
                    return (
                        <tr key={item.nickname}>
                           <td>
                                <img src={avatar_src} alt="Avatar" className='avatar-contact'/>
                            </td>
                            <td>
                                <button  value ={item.id} className={item.id === selectedContactId ? 'button-users-selected':'button-users'} onClick={onClickContact}>
                                   {item.username} 
                                </button>
                            </td>
                            
                            
                                                     
                        </tr>
                                     
                        )
                    }
                }
        
                )
            );
            
        } else return null;
        
    }

    //RENDER TEXT CONTAINER AND SEND BUTTON
    const renderSendTextBox = () => {
        return (
            <div className="text-container">
                    
                    <label htmlFor="name-account" >Текст для сообщения</label>
                    <textarea  className='text-message' placeholder="Посмотрите данную ссылку. " onChange={handleTextMessage}></textarea> 
                    <button  value={selectedContactId} className="send-button" onClick={onClickSend}>Отправить</button>
                </div>
        )
    };


    
        return (
            <div className="ContactsData">
                <div className='table-div'>
                                <table>
                                    <tbody>
                                    {renderContactsData()}
                                    </tbody>
                                </table>
                </div>

                {selectedContactId ? renderSendTextBox(): null}
                     
                
                   
            </div>
        )
   
}
export default ContactsData;